import { Box, ClickAwayListener, Popover } from "@mui/material";
import { Dashboard } from "../../../../../types/files";
import CommentaryContentCard from "../../../../molecules/home-companies/CommentaryContentCard";

const CommentaryModal: React.FC<{
    open: boolean,
    dashboard: Dashboard,
    newCommentary?: boolean,
    anchorElement?: HTMLElement|null,
    onClose: () => void,
 }> = ({ open, dashboard, anchorElement, newCommentary, onClose }) => {
    return (<>
        <Popover open={open} anchorEl={anchorElement}>
            <ClickAwayListener onClickAway={onClose}>
                <Box width="fit-content" height="fit-content">
                    <CommentaryContentCard newCommentary={newCommentary} dashboard={dashboard} />
                </Box>
            </ClickAwayListener>
        </Popover>
    </>);
}

export default CommentaryModal;